import { useEffect } from "react";
import { useProgress } from "./useProgress";
import { track } from "@/lib/track";
import { MODULES } from "@/lib/curriculum";

/**
 * Watches progress and fires "module_complete" / "certificate_earned" events
 * exactly once per milestone (guarded by localStorage so refreshes don't
 * double-count). Mounted once at the app root.
 */
export function useStatsTracking() {
  const { moduleCompletion, allComplete } = useProgress();

  // Module completions
  useEffect(() => {
    for (const m of MODULES) {
      const mc = moduleCompletion[m.id];
      if (mc && mc.total > 0 && mc.done >= mc.total) {
        const flag = `bch-school:tracked:module:${m.id}`;
        try {
          if (localStorage.getItem(flag) !== "1") {
            localStorage.setItem(flag, "1");
            track("module_complete");
          }
        } catch {
          /* ignore storage errors */
        }
      }
    }
  }, [moduleCompletion]);

  // Certificate earned
  useEffect(() => {
    if (!allComplete) return;
    const flag = "bch-school:tracked:certificate";
    try {
      if (localStorage.getItem(flag) !== "1") {
        localStorage.setItem(flag, "1");
        track("certificate_earned");
      }
    } catch {
      /* ignore storage errors */
    }
  }, [allComplete]);
}
